export class UserPhlebotomist {
  Id?: number;
  FirstName: string;
  LastName: string;
  MiddleName?: string;
  Email: string;
  Phone: string;

  constructor() {
    this.FirstName = "";
    this.LastName = "";
    this.MiddleName = "";
    this.Phone = "";
    this.Email = "";
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/models/phlebotomists.model.ts